import { newToolFilterOAuthMcp } from "../oauth.ts";

export const stytchMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://stytch.com/favicon.ico",
  url: "https://mcp.stytch.dev/mcp",
  label: "Stytch",
});
